export {};
//# sourceMappingURL=periodic-wave-options.js.map